module.exports = __webpack_public_path__ + "img/party.959ffad2.png";